/** 碳足迹单位：1=吨(tCO₂eq)，2=千克(kgCO₂eq)，3=克(gCO₂eq) */
export function isValidLifecycleCarbonUnit(val) {
  const n = Number(val);
  return n === 1 || n === 2 || n === 3;
}

export function normalizeLifecycleCarbonUnit(val) {
  if (val === '' || val === undefined || val === null) {
    return '';
  }
  return isValidLifecycleCarbonUnit(val) ? Number(val) : '';
}

export const CARBON_UNIT_OPTIONS = [
  { value: 2, label: 'kgCO₂eq(千克二氧化碳当量)' },
  { value: 1, label: 'tCO₂eq(吨二氧化碳当量)' },
  { value: 3, label: 'gCO₂eq(克二氧化碳当量)' },
];
